export default "__VITE_ASSET__D42Y$w7t__"